import { render } from "./JournalRoot.vue?vue&type=template&id=a92792ba&scoped=true"
import script from "./JournalRoot.vue?vue&type=script&lang=js"
export * from "./JournalRoot.vue?vue&type=script&lang=js"

import "./JournalRoot.vue?vue&type=style&index=0&id=a92792ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a92792ba"]])

export default __exports__